import {IconWrapper} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  "data-slot": "icon",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.379 21h3.242M6.312 10.468c0-3.023 2.547-5.474 5.688-5.474 3.141 0 5.688 2.451 5.688 5.474 0 1.657-.766 3.142-1.974 4.146-.511.424-.95.95-1.117 1.593l-.227.875a1.22 1.22 0 0 1-1.18.912h-2.38a1.22 1.22 0 0 1-1.18-.912l-.227-.875c-.167-.643-.606-1.169-1.117-1.593-1.208-1.004-1.973-2.489-1.973-4.146Z" }, null, -1)
  ])))
}
export default { render() { return h(IconWrapper, {icon: {render}, name: "bulb-off"}) } }